export const FeedbackIcon = Object.freeze({
  Happy: 1,
  Sad: 2,
});

export const TransactionType = {
  Manual: "Manual", 
  Auto: "Auto",
};

export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType];
// export const ExportMode = [
//   TransactionType.Manual,
//   TransactionType.Auto,
// ];

// export const ImportMode = [
//   TransactionType.Manual,
//   TransactionType.Auto,
// ];


export enum HubspotIntegrationType {
  Export = "CONTACTS_EXPORT",
  Import = "CONTACTS_IMPORT",
}

export const IntegrationHubspotTypeCode = {
  [HubspotIntegrationType.Export]: "export",
  [HubspotIntegrationType.Import]: "import",
} as const;

export const IntegrationHubspotCode = {
  [HubspotIntegrationType.Export]: "CONTACTS_EXPORT",
  [HubspotIntegrationType.Import]: "CONTACTS_IMPORT",
} as const;

export const IntegrationTypeText = {
  [HubspotIntegrationType.Export]: "Exportar",
  [HubspotIntegrationType.Import]: "Importar",
}

export const IntegrationTypeSync = {
  [HubspotIntegrationType.Export]: "exportable",
  [HubspotIntegrationType.Import]: "importable",
}

export enum IntegrationMode {
  Manual = "manual",
  Auto = "auto",
}

export const IntegrationModeNumber = {
  [IntegrationMode.Manual]: 1,
  [IntegrationMode.Auto]: 2,
} as const;

export const INTEGRATION_CONFIG = {
  [HubspotIntegrationType.Export]: {
    title: "Exportar contactos de BeexCC a HubSpot",
    hint: `Activa esta opción para exportar tus contactos a HubSpot de forma individual o masiva, y para actualizar contactos exportados o importados que sean editados desde BeexCC. Recuerda que <b>la exportación será a una misma cuenta de HubSpot</b>, sin distinguir empresa o campaña.`,
    defaultMode: IntegrationMode.Manual,
    eventText: 'Exportación de contactos',
    eventProcess: 'Exportando contactos...',
    modes: {
      [IntegrationMode.Manual]: {
        title: "Manual",
        description: `Exporta tus contactos de BeexCC a HubSpot cuando lo necesites. Todos 
          los contactos exportados o importados que sean editados desde 
          BeexCC, se tendrán que <strong>actualizar manualmente.</strong>`,
      },
      [IntegrationMode.Auto]: {
        title: "Automático",
        description: `Todos los nuevos contactos que se creen en BeexCC se exportarán
          automáticamente a HubSpot. <strong>Los contactos existentes no se
          exportarán de forma automática</strong>, pero puedes exportarlos desde aquí. 
          Todos los contactos exportados o importados que sean editados desde BeexCC, se
          <strong> actualizarán automáticamente.</strong>`,
      },
    },
  },
  [HubspotIntegrationType.Import]: {
    title: "Importar contactos de HubSpot a BeexCC",
    hint: `Activa esta opción para importar tus contactos de HubSpot de forma 
      individual o masiva, y para actualizar contactos exportados o importados 
      que sean editados desde HubSpot. Recuerda que <strong>la importación será según 
      la empresa y campaña</strong>, y los contactos deben cumplir con los `,
    defaultMode: IntegrationMode.Manual,
    eventText: 'Importación de contactos',
    eventProcess: 'Importando contactos...',
    modes: {
      [IntegrationMode.Manual]: {
        title: "Manual",
        description: `Importa tus contactos de HubSpot que cumplan con los criterios de 
          importación de BeexCC. Todos los contactos importados o exportados 
          que sean editados desde HubSpot, se tendrán que <strong>actualizar 
          manualmente desde BeexCC</strong>.`,
      },
      [IntegrationMode.Auto]: {
        title: "Automático",
        description: `Todos los nuevos contactos que se creen en HubSpot y cumplan los 
          criterios de importación de BeexCC, se importarán automáticamente. 
          Los contactos existentes no se importarán de forma automática, pero 
          puedes importarlos desde aquí. Todos los contactos importados o 
          exportados que sean editados desde HubSpot, serán <strong>actualizados 
          automáticamente</strong>.`,
      },
    },
  },
};